import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { bindActionCreators } from 'redux';
import { HEADER, APPOINTMENTS, REFERRAL } from '_constants';
import { headerActions, appointmentActions } from 'actions';
import { APPOINTMENT_STATUS } from '../../../constants/appointments.constants';
import StepInstruction from '../../common/StepInstruction';

class CompleteAppointment extends React.Component {
    static propTypes = {
      appointments: PropTypes.object.isRequired,
      appointment: PropTypes.object.isRequired,
      fetchDispositions: PropTypes.func.isRequired,
      getSelectDisposition: PropTypes.func.isRequired,
      setHeader: PropTypes.func.isRequired,
      completeAppointment: PropTypes.func.isRequired,
      history: PropTypes.object.isRequired,
      displayDispositionInfo: PropTypes.func.isRequired,
      referral: PropTypes.object.isRequired
    }

    state = {
      selectedReason: APPOINTMENTS.SELECT_REASON,
      completeNotes: '',
      countMet: false,
      triedToSubmit: false,
      step1: { num: 1, bgColor: 'bg-blue-shade', showCheckMark: false },
      step2: { num: 2, bgColor: 'bg-silver', showCheckMark: false },
      selectItems: [],
      updatedDispositions: []
    }

    confirmCount = () => {
      if (this.state.completeNotes.length >= 20) {
        this.setState((state) => ({
          countMet: true,
          step2: { ...state.step2, showCheckMark: true }
        }));
      } else {
        this.setState((state) => ({
          countMet: false,
          step2: { ...state.step2, showCheckMark: false }
        }));
      }
    }

    onChangeAction = (event) => {
      const reason = event.target.value;
      this.setState((state) => ({
        selectedReason: reason,
        step1: { ...state.step1, showCheckMark: true },
        step2: { ...state.step2, bgColor: 'bg-blue-shade' }
      }));
    }

    handleChange = (event) => {
      this.setState({
        completeNotes: event.target.value
      }, this.confirmCount);
    }

    handleClick = () => {
      this.setState((state) => ({
        step2: { ...state.step2, bgColor: 'bg-blue-shade' }
      }));
    }

    completeAppointment = (history) => {
      const isFromAppointmentDetails = _.get(this.props, 'location.state.from', null);
      this.setState({ triedToSubmit: true });
      if (this.state.countMet && this.state.selectedReason !== APPOINTMENTS.SELECT_REASON) {
        this.props.appointment.notes = this.state.completeNotes;
        if (_.isEqual(isFromAppointmentDetails, 'appointmentDetails')) {
          this.props.completeAppointment(this.props.appointment, this.state.selectedReason, history, true);
        } else {
          this.props.completeAppointment(this.props.appointment, this.state.selectedReason, history);
        }
      }
    }

    componentDidMount = async () => {
      this.props.setHeader({
        type: HEADER.UPDATE_HEADER,
        showHeader: true,
        headerTitle: 'Complete Appointment',
        hasBackButton: true,
        backButtonIcon: 'back'
      });
      await this.props.fetchDispositions(APPOINTMENT_STATUS.COMPLETED.id);
      const { appointments, appointment, referral } = this.props;
      const dispositionList = appointments && appointments.dispositions && appointments.dispositions[APPOINTMENT_STATUS.COMPLETED.id];
      const { selectItems, updatedDispositions } = this.props.getSelectDisposition(dispositionList, appointment, referral);
      this.setState({
        selectItems,
        updatedDispositions,
        selectedReason: updatedDispositions.length === 1 ? updatedDispositions[0]?.disposition?.dispositionKey : APPOINTMENTS.SELECT_REASON
      });
    }

    render () {
      const { completeNotes, selectedReason, countMet, triedToSubmit, step1, step2, selectItems, updatedDispositions } = this.state;
      const checkMark = <span>&#10003;</span>;

      return (
        <React.Fragment>
          <div className='complete-appointment-label'>
            <StepInstruction badgeDisplay={step1.showCheckMark ? checkMark : step1.num} bgcolor={step1.bgColor} />
            <div className={'complete-reason-info'}>
              <span className={'question'}>Why are you completing?</span>
              {!_.isEmpty(updatedDispositions) && <i className={'material-icons material-icons-info description-icon'} onClick={() => this.props.displayDispositionInfo(updatedDispositions, 'Completing Reasons')} />}
            </div>
            {
              triedToSubmit && selectedReason === APPOINTMENTS.SELECT_REASON &&
              <span className={'sub-label-text'}> *Please select the reason</span>
            }
          </div>
          <div className='margin-lr-10 select-status-custom'>
            <select className='reason form-control' value={this.state.selectedReason} onChange={this.onChangeAction}>
              {selectItems}
            </select>
          </div>
          <div className='pd-10'>
            <StepInstruction badgeDisplay={step2.showCheckMark ? checkMark : step2.num} bgcolor={step2.bgColor} />
            <span>Notes</span>
            {
              triedToSubmit && !countMet
                ? <span className='sub-label-text'> *Please enter at least 20 characters</span>
                : <span className='appointment-small-text'> (20 characters min.)</span>
            }
          </div>
          <div className='margin-lr-10'>
            <textarea
              className='appointment-notes'
              placeholder=' Complete Appointment Notes'
              maxLength='160'
              rows='4'
              onChange={this.handleChange}
              onClick={this.handleClick}
            />
          </div>
          <div className='text-characters-count'>
            {`(${completeNotes.length}/160)`}
          </div>
          <div className='appointment-disclaimer'>
            <div className='float-left alert-red-text'>*</div>
            <div>{REFERRAL.NOTE_DISCLAMIER}</div>
          </div>
          <div className='bottom-container'>
            <button
              className='appointment-primary-button'
              onClick={() => this.completeAppointment(this.props.history)}>Complete Appointment
            </button>
          </div>
        </React.Fragment>
      );
    }
}

const mapStateToProps = (state) => {
  return {
    appointments: state.appointments
  };
};

const mapDispatchToProps = dispatch => ({
  setHeader: bindActionCreators(headerActions.setHeader, dispatch),
  completeAppointment: bindActionCreators(appointmentActions.completeAppointment, dispatch)
});
export default connect(mapStateToProps, mapDispatchToProps)(withRouter(CompleteAppointment));
